require('./openYoungHistoryTableRow.scss');
// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { LabelDate } = require('commonsComponents/labelDate');

// @constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const {
    EURO_TEXT
} = require('constants/index');
const {
    REQUEST_MONEY,
    SAVE_MONEY,
    statusList,
    statusMapping,
} = require('constants/openYoungHistory');

// @ utilities
const { formatCurrency, getFormattedString } = require('utilities/currencyHelper');
const { hash } = require('utilities/hash');
const { getLanguage, FormattedText } = require('core/i18n').i18n;

class OpenYoungHistoryTableRow extends React.Component {
    constructor(props){
        super(props);
        this.buildRowButtons = this.buildRowButtons.bind(this);
        this.handleOnClick = this.handleOnClick.bind(this);
    }

    handleOnClick(path) {
        const { history, immCards, immTransaction } = this.props;
        let hashedPan = '';

        immCards.get('byId').every((immCard) => {
            const fullPanNumber = immCard.getIn(['interventionList', 0, 'pan']);
            const last4DigitPanCard = fullPanNumber.substr(fullPanNumber.length - 4);
            const isPanNumberMatched = immTransaction.get('pan') === last4DigitPanCard;
            if(isPanNumberMatched){
                hashedPan = hash(fullPanNumber);
            }
            return !isPanNumberMatched;
        });
        history.push(`/myprofile/cards/${hashedPan}/${path}`);
    }

    buildRowButtons() {
        const { immTransaction } = this.props;
        if (immTransaction.getIn(['requestStatus']) === statusMapping['pending']) {
            if (immTransaction.getIn(['requestType']) === REQUEST_MONEY){
                return (
                    <React.Fragment>
                        <span className="open-young-history-table-row__accept-button">
                            <OKButton
                                modifier="secondary"
                                size="small"
                                onClick={() => this.handleOnClick('accept/moneyrequest')}
                            >
                                <FormattedText value="openYoungHistoryView-openYoungHistoryView_acceptButton" format="firstUppercase"/>
                            </OKButton>
                        </span>
                        <span className="open-young-history-table-row__reject-button">
                            <OKButton
                                modifier="ghost"
                                size="small"
                                onClick={() => this.handleOnClick('reject/moneyrequest')}
                            >
                                <FormattedText value="openYoungHistoryView-openYoungHistoryView_rejectButton" format="firstUppercase"/>
                            </OKButton>
                        </span>
                    </React.Fragment>
                );
            } else if(immTransaction.getIn(['requestType']) === SAVE_MONEY) {
                return (
                    <React.Fragment>
                        <span className="open-young-history-table-row__accept-button">
                            <OKButton
                                modifier="secondary"
                                size="small"
                                onClick={() => this.handleOnClick('accept/savingsrequest')}
                            >
                                <FormattedText value="moneySavingsRequest-acceptButton" format="firstUppercase"/>
                            </OKButton>
                        </span>
                        <span className="open-young-history-table-row__reject-button">
                            <OKButton
                                modifier="ghost"
                                size="small"
                                onClick={() => this.handleOnClick('reject/savingsrequest')}
                            >
                                <FormattedText value="moneySavingsRequest-rejectButton" format="firstUppercase"/>
                            </OKButton>
                        </span>
                    </React.Fragment>
                );
            }
        }
    }


    render() {
        const {
            id,
            immTransaction
        } = this.props;
        const reward = getFormattedString({
            amount: immTransaction.get('requestAmount'),
            currency: formatCurrency(EURO_TEXT),
        });
        let tableRow;
        if (!!immTransaction) {
            tableRow = (
                <OKTableRow id={id}>
                    <OKTableCell>
                        <LabelDate
                            date={immTransaction.get('requestDate')}
                            language={getLanguage()}
                            today={LABEL_DATE_TODAY}
                            yesterday={LABEL_DATE_YESTERDAY}
                        />
                    </OKTableCell>
                    <OKTableCell>
                        <FormattedText value={`openYoungHistoryView-openYoungHistoryView_${statusList[immTransaction.get('requestStatus')]}`}/>
                    </OKTableCell>
                    <OKTableCell>
                        <FormattedText value="openYoungHistoryView-openYoungHistoryView_requestFrom" injectedStrings={[immTransaction.get('childName')]}/>
                    </OKTableCell>
                    <OKTableCell>
                        {immTransaction.getIn(['childComment'])}
                    </OKTableCell>
                    <OKTableCell>
                        {reward}
                    </OKTableCell>
                    <OKTableCell>
                        {this.buildRowButtons()}
                    </OKTableCell>
                </OKTableRow>
            );
        }
        return tableRow;
    }
}

OpenYoungHistoryTableRow.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
};

module.exports = connect(
    state => ({
        immCards: state.cards
    }),
    null
)(withRouter(OpenYoungHistoryTableRow));
